import { render, staticRenderFns } from "./addreviews.vue?vue&type=template&id=440b714b&scoped=true"
import script from "./addreviews.vue?vue&type=script&lang=js"
export * from "./addreviews.vue?vue&type=script&lang=js"
import style0 from "./addreviews.vue?vue&type=style&index=0&id=440b714b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440b714b",
  null
  
)

export default component.exports